import React from "react";

const TabDescription = ({ tabDescription }) => {
  return (
    <div
      className="tab-pane fade show active"
      id="pills-home"
      role="tabpanel"
      aria-labelledby="pills-home-tab"
      tabIndex={0}
    >
      <div
        className="menu_det_description"
        dangerouslySetInnerHTML={{ __html: tabDescription }}
      >
        {/* <p>
          Ipsum dolor, sit amet consectetur adipisicing elit. Doloribus
          consectetur ullam in? Beatae, dolorum ad ea deleniti ratione
          voluptatum similique omnis voluptas tempora optio soluta vero
          veritatis reiciendis blanditiis architecto. Debitis nesciunt inventore
          voluptate tempora ea incidunt iste, corporis, quo cumque facere
          doloribus possimus nostrum sed magni quasi, assumenda autem!
          Repudiandae nihil magnam provident illo alias vero odit repellendus,
          ipsa nemo itaque. Aperiam fuga, magnam quia illum minima blanditiis
          tempore. vero veritatis reiciendis blanditiis architecto. Debitis
          nesciunt inventore voluptate tempora ea incidunt iste, corporis, quo
          cumque facere doloribus possimus nostrum sed magni quasi
        </p>
        <ul>
          <li>
            Lorem ipsum dolor sit amet consectetur adipisicing elit Doloribus.
          </li>
          <li>
            Dolor sit amet consectetur adipisicing elit. Earum itaque nesciunt.
          </li>
          <li>
            Corporis quo cumque facere doloribus possimus nostrum sed magni
            quasi.
          </li>
          <li>
            Incidunt iste corporis quo cumque facere doloribus possimus nostrum
            sed.
          </li>
          <li>
            Incidunt iste corporis quo cumque facere doloribus possimus nostrum
            sed.
          </li>
          <li>Architecto Debitis nesciunt inventore voluptate tempora ea.</li>
          <li>
            Earum itaque nesciunt dolor laudantium placeat sed velit aspernatur.
          </li>
          <li>
            Laudantium placeat sed velit aspernatur nobis quos quibusdam
            distinctio.
          </li>
        </ul>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum itaque
          nesciunt dolor laudantium placeat sed velit aspernatur, nobis quos
          quibusdam distinctio voluptatum officia vel sapiente enim,
          reprehenderit impedit beatae molestias dolorum. A laborum consectetur
          sed quis exercitationem optio consequatur, unde neque est odit,
          pariatur quae incidunt quasi dolorem nihil aliquid ut veritatis porro
          eaque cupiditate voluptatem vel ad! Asperiores, praesentium. sit amet
          consectetur adipisicing elit. Doloribus consectetur ullam in? Beatae,
          dolorum ad ea deleniti ratione voluptatum similique omnis voluptas
          tempora optio soluta
        </p>
        <ul>
          <li>
            Reiciendis blanditiis architecto. Debitis nesciunt inventore
            voluptate
          </li>
          <li>
            Lorem ipsum dolor sit amet consectetur adipisicing elit Doloribus.
          </li>
          <li>
            Dolor sit amet consectetur adipisicing elit. Earum itaque nesciunt.
          </li>
          <li>
            Corporis quo cumque facere doloribus possimus nostrum sed magni
            quasi.
          </li>
          <li>
            Incidunt iste corporis quo cumque facere doloribus possimus nostrum
            sed.
          </li>
          <li>
            Incidunt iste corporis quo cumque facere doloribus possimus nostrum
            sed.
          </li>
        </ul>
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloribus
          consectetur ullam in? Beatae, dolorum ad ea deleniti ratione
          voluptatum similique omnis voluptas tempora optio soluta vero
          veritatis reiciendis blanditiis architecto. Debitis nesciunt inventore
          voluptate tempora ea incidunt iste, corporis, quo cumque facere
          doloribus possimus nostrum sed magni quasi, assumenda autem!
          Repudiandae nihil magnam provident illo alias vero odit repellendus,
          ipsa nemo itaque. Aperiam fuga, magnam quia illum minima blanditiis
          tempore.
        </p> */}
      </div>
    </div>
  );
};

export default TabDescription;
